import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { get, isEmpty } from 'lodash';
import { airtableMarkdownToHtml } from '../../../../../utils/airtable';

import loadable from '@loadable/component';

const NotFound = loadable(() =>
  import('../../../../components/not_found_component/not_found_component')
);
const AdContainer = loadable(() =>
  import('../../../../components/ad/AdContainer')
);
const Section = loadable(
  () => import('../../../../fc-components/main/components'),
  {
    resolveComponent: components => components.Section
  }
);
const Image = loadable(
  () => import('../../../../fc-components/main/components'),
  {
    resolveComponent: components => components.Image
  }
);
const Text = loadable(
  () => import('../../../../fc-components/main/components'),
  {
    resolveComponent: components => components.Text
  }
);
const MultiTabList = loadable(
  () => import('../../../../fc-components/main/components'),
  {
    resolveComponent: components => components.MultiTabList
  }
);
const FranchiseTopper = loadable(
  () => import('../../../../fc-components/main/components'),
  {
    resolveComponent: components => components.FranchiseTopper
  }
);
const StickyBar = loadable(
  () => import('../../../../components/StickyBar/StickyBar'),
  {
    resolveComponent: components => components.StickyBar
  }
);
const Button = loadable(
  () => import('../../../../fc-components/main/components'),
  {
    resolveComponent: components => components.Button
  }
);

const Footer = loadable(() => import('../../../../components/footer/footer'));

const parseWinners = winner => ({
  category: winner.category || 'Lorem Ipsum',
  company: winner.company || 'Lorem Ipsum',
  description: winner.description || 'Lorem Ipsum donnor',
  icon:
    winner.icon ||
    'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2022/09/IBD_Design-Co-of-the-Year.png',
  image:
    winner.image ||
    'https://images.fastcompany.net/image/upload/wp-cms/uploads/2022/07/p-1-ibd-2022-dcoy_W.jpg',
  title: winner.title || 'lorem Ipsum',
  url: winner.url || 'https://www.test.com'
});
const parseHonorees = honoree => ({
  description: honoree.description || 'Lorem Ipsum donnor',
  icon:
    honoree.icon ||
    'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2022/09/IBD_Design-Co-of-the-Year.png',
  title: honoree.title || 'lorem Ipsum',
  url: honoree.url || 'https://www.test.com'
});
const shareIcon = () => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.36328 12.4871C2.80265 12.4873 2.26505 12.2647 1.8684 11.8684C1.47189 11.4723 1.24901 10.9348 1.24887 10.3743C1.24872 9.81371 1.47116 9.27606 1.86736 8.87961C2.26358 8.48317 2.80117 8.26019 3.36181 8.25993C3.92229 8.25964 4.46018 8.48204 4.85669 8.87818C5.25335 9.27433 5.47633 9.81168 5.47678 10.3722C5.47663 10.9328 5.25391 11.4703 4.85769 11.8669C4.46133 12.2634 3.92388 12.4864 3.36324 12.4871H3.36328ZM16.6141 14.8836C17.1748 14.8836 17.7124 15.1063 18.1087 15.5026C18.5052 15.8987 18.728 16.4362 18.7281 16.9968C18.7283 17.5572 18.5057 18.0948 18.1095 18.4912C17.7131 18.8877 17.1757 19.1105 16.615 19.1108C16.0545 19.1109 15.5168 18.8885 15.1201 18.4925C14.7236 18.0964 14.5006 17.559 14.5002 16.9985C14.5003 16.4378 14.7231 15.9002 15.1194 15.5036C15.5158 15.1072 16.0534 14.8841 16.6142 14.8836L16.6141 14.8836ZM16.6141 1.63643C17.1749 1.63643 17.7127 1.85926 18.1091 2.2557C18.5055 2.65215 18.7282 3.1898 18.7281 3.75045C18.7279 4.31114 18.5051 4.84879 18.1084 5.24509C17.7118 5.64138 17.174 5.86392 16.6133 5.86363C16.0525 5.86334 15.5149 5.64036 15.1185 5.2438C14.7223 4.84721 14.4999 4.30929 14.5002 3.74876C14.5009 3.18851 14.7238 2.65145 15.1201 2.25545C15.5165 1.85945 16.0538 1.63672 16.6141 1.63643ZM16.6141 7.10915C17.56 7.1093 18.4623 6.71112 19.0996 6.01225C19.7369 5.31337 20.0504 4.37843 19.963 3.4367C19.8757 2.49483 19.3957 1.63344 18.6409 1.06369C17.8859 0.49379 16.9259 0.268226 15.9961 0.442125C15.0663 0.616161 14.2527 1.17354 13.755 1.97778C13.2573 2.78201 13.1214 3.75871 13.3805 4.66833L6.03822 8.33831C5.46649 7.58689 4.60511 7.11044 3.66455 7.02565C2.72411 6.94072 1.79133 7.25525 1.09421 7.89209C0.397098 8.52905 0 9.42961 0 10.3738C0 11.3179 0.397061 12.2185 1.09421 12.8555C1.79133 13.4923 2.72414 13.8068 3.66455 13.7219C4.60514 13.6371 5.46653 13.1607 6.03822 12.4092L13.3805 16.0792C13.0685 17.1666 13.3221 18.3379 14.0559 19.199C14.7899 20.06 15.9064 20.496 17.0297 20.3604C18.153 20.2247 19.1335 19.5353 19.6412 18.5243C20.1488 17.5134 20.1161 16.3153 19.5539 15.3336C18.9918 14.3518 17.9751 13.7169 16.8461 13.6427C15.7172 13.5686 14.626 14.0649 13.9403 14.9646L6.59649 11.2921C6.7681 10.6919 6.7681 10.0557 6.59649 9.45556L13.9403 5.783C14.5752 6.61863 15.5644 7.10948 16.6141 7.10948L16.6141 7.10915Z"
      fill="black"
    />
  </svg>
);

const InnovationByDesignFranchisePage = ({ franchisePage }) => {
  const [isMobile, setIsMobile] = useState(null);
  const [activeTab, setActiveTab] = useState(0);
  const [tabLists, setTabLists] = useState([]);
  const franchiseCategory = get(franchisePage, 'data.franchiseCategory');
  const franchiseSlug = get(franchisePage, 'data.slug', 'default');
  const checkIfMobile = x => {
    setIsMobile(x.matches);
  };

  const dataArr = [{}, {}];
  const airTableData = get(franchisePage, 'data.externalList', []);

  // Fields to map to airtable keys (Make sure airtable keys match with Table component this data is fed to)
  const winnersFields = [
    { label: 'icon', name: 'icon', weight: '1', width: '50' },
    { label: 'title', name: 'titles', weight: '1', width: '200' },
    { label: 'description', name: 'description', weight: '1', width: '253' },
    { label: 'image', name: 'image', weight: '1', width: '350' }
  ];

  const honoreesFields = [
    { label: 'icon', name: 'icon', weight: '1', width: '50' },
    { label: 'title', name: 'titles', weight: '1', width: '' },
    { label: 'description', name: 'description', weight: '0', width: '' }
  ];

  dataArr.forEach((tab, idx) => {
    /* eslint-disable no-param-reassign */
    tab.behavior = 'link';
    tab.category = idx === 0 ? 'Winners' : 'Honorees';
    tab.data =
      idx === 0
        ? airTableData.winners.map(parseWinners)
        : airTableData.honorees.map(parseHonorees);
    tab.fields = idx === 0 ? winnersFields : honoreesFields;
    tab.image = false;
    tab.type = 'company_list';
    tab.index = idx;
  });

  // Detect screen size on render, and watch for changes to it.
  useEffect(() => {
    const x = window.matchMedia('(max-width: 640px)');
    checkIfMobile(x);
    x.addListener(checkIfMobile);

    const query = window.location.search.replace('?', '').split('=');

    if (query[0] === 'view') setActiveTab(parseInt(query[1], 8));

    setTabLists(dataArr);
  }, []);

  useEffect(
    () => {
      if (isMobile) setActiveTab(0);
    },
    [isMobile]
  );

  const pageMetadata = get(franchisePage, 'data.externalList.metadata[0]');
  const year = get(pageMetadata, 'Year', 2023);
  const pageTitle = get(pageMetadata, 'PageTitle', '');
  const seoSubHeadline = get(pageMetadata, 'Subhead', '');
  const franchiseContributors = airtableMarkdownToHtml(
    get(pageMetadata, 'Contributors', '')
  );
  const franchiseApplyTitle = get(pageMetadata, 'registerTitle');
  const franchiseApplyCopy = get(pageMetadata, 'registerCopy');
  const franchiseApplyCTACopy = get(pageMetadata, 'registerCTACopy');

  const franchisePrevYearsTitle = get(pageMetadata, 'pastYearsTitle');
  const franchisePrevYearsCopy = get(pageMetadata, 'pastYearsCopy');

  const featureImageDesktop = get(pageMetadata, 'featureimage (desktop)');
  const featureImageMobile = get(
    pageMetadata,
    'featureimage (mobile)',
    featureImageDesktop
  );
  const blurbImage = get(pageMetadata, 'Blurb image');
  const franchiseHeroImageCaption = get(
    pageMetadata,
    'featureimage caption',
    'no caption'
  );
  const franchiseBlurb = airtableMarkdownToHtml(get(pageMetadata, 'Blurb', ''));

  // Handle the Advertising Data
  const interstitialFreq = 10;
  const interstitial = (
    <React.Fragment>
      <AdContainer type="break" />
    </React.Fragment>
  );

  const goToTopOfList = () => {
    const distance =
      window.pageYOffset +
      document.querySelector('.tableSection').getBoundingClientRect().top;
    window.scrollTo({ top: distance - 60, left: 0, behavior: 'smooth' });
  };

  const handlePreviousYearChange = event => {
    if (event.target.value !== '') {
      // open previous list in new tab
      window.open(`/innovation-by-design/${event.target.value}`, '_blank');
    }
  };

  const handleClickToApply = () =>
    window.open(
      'https://www.fastcompany.com/apply/innovation-by-design',
      '_blank'
    );

  if (
    franchisePage.error ||
    // eslint-disable-next-line
    // status === 404 ||
    isEmpty(franchisePage) ||
    year < 2012 ||
    !year
  ) {
    return (
      <section className="ibd-page">
        <article className="ibd-page__main--error-pg">
          <NotFound />
        </article>
      </section>
    );
  }

  return (
    <div className="ibd2023" id="editorialLander">
      <Section
        bdColor="transparent"
        name="franchise-headline"
        maxWidth={970}
        noPadding
      >
        <FranchiseTopper headline={pageTitle} subHeadline={seoSubHeadline} />
      </Section>
      <Section
        name="heroSectionContainer"
        bgColor="transparent"
        maxWidth={1110}
      >
        <div className="heroImage">
          <Image
            image={isMobile ? featureImageMobile : featureImageDesktop}
            caption={franchiseHeroImageCaption}
          />
        </div>
      </Section>
      <div className="introSection">
        <Section bgColor="transparent !important" maxWidth={810}>
          <div className="introText">
            <Text>
              <Image image={blurbImage} width="85px" float="left" />
              <div className="content">
                <div dangerouslySetInnerHTML={{ __html: franchiseBlurb }} />
              </div>
            </Text>
          </div>
        </Section>
      </div>
      <div className="tableSection">
        <Section bgColor="#f7f7f7" maxWidth={1020} scrollHere noPadding>
          <MultiTabList
            list={franchiseCategory}
            data={tabLists}
            interstitialUnit={interstitial}
            interstitialFreq={interstitialFreq}
            isMobile={isMobile}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
        </Section>
      </div>
      <div className="applySection">
        <Section
          addClass="applySection"
          name="franchise-apply-section"
          noPadding
        >
          <h2>{franchiseApplyTitle}</h2>
          <p>{franchiseApplyCopy}</p>
          <Button
            bgColor="#000"
            labelColor="#FFFFFF"
            labelHoverColor="#FFFFFF"
            hoverColor="#D7D7D7"
            rounded
            label={franchiseApplyCTACopy}
            onClick={handleClickToApply}
          />
        </Section>
      </div>
      <div className="perviousYearsSection">
        <Section
          addClass="perviousYearsSection"
          name="franchise-apply-section"
          noPadding
        >
          <h2>{franchisePrevYearsTitle}</h2>
          <p>{franchisePrevYearsCopy}</p>
          <form>
            <label htmlFor="yearDropdown">Choose year</label>
            <div className="select-container">
              <select onChange={handlePreviousYearChange} name="yearDropdown">
                <option value="2022">2022</option>
                <option value="2021">2021</option>
                <option value="2020">2020</option>
                <option value="2019">2019</option>
                <option value="2018">2018</option>
              </select>
            </div>
          </form>
        </Section>
      </div>
      <div className="creditsSection">
        <Section addClass="creditsSection" name="franchise-credits" noPadding>
          <span
            className="section__franchise-credits--content"
            dangerouslySetInnerHTML={{ __html: franchiseContributors }}
          />
        </Section>
      </div>
      <div className="footer-ad-container">
        <AdContainer type="footer" />
      </div>
      <Footer />
      <StickyBar
        slug={franchiseSlug}
        externalData={dataArr} // Category data coming from Airtable not WP
        lists={tabLists}
        location="lander"
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        overrideShareIcon={shareIcon()}
        isMobile={isMobile}
        post={{
          id: 'innovation-by-design',
          slug: franchiseSlug,
          title: pageTitle
        }}
        scroll={goToTopOfList}
        position="sticky"
      />
    </div>
  );
};

InnovationByDesignFranchisePage.propTypes = {
  franchisePage: PropTypes.shape({}).isRequired
};

export default InnovationByDesignFranchisePage;
